import { cn } from '@/lib/utils';
import { DEFS } from '@/canvas/defs/index';
import { canvasLabel, statusKey } from '@/components/canvas/bits';

export const SQUARE = {
  Confirmed: 'bg-success',
  'In progress': 'bg-warning',
  Review: 'bg-highlight',
  'Not started': 'bg-muted-foreground/25',
};

// ten small squares, one per canvas, in the colour of its status
export function StatusSquares({ states, className }) {
  return (
    <ul className={cn('flex flex-wrap gap-1', className)} aria-label="Status of each canvas">
      {DEFS.map((d) => {
        const key = statusKey(states[d.no]);
        return (
          <li
            key={d.no}
            title={`${canvasLabel(d)}: ${key}`}
            aria-label={`${canvasLabel(d)}: ${key}`}
            className={cn('flex size-5 items-center justify-center rounded text-[10px] font-semibold', SQUARE[key], key === 'Not started' ? 'text-muted-foreground' : key === 'Review' ? 'text-highlight-foreground' : 'text-white')}
          >
            {d.no}
          </li>
        );
      })}
    </ul>
  );
}
